import data from "../../../../../packages/react/src/drafts/MarkdownViewer/MarkdownViewer.docs.json";
import * as React from 'react';
export default {
  data,
  React
};